import { api } from '../../../shared/services/api'

import type {
  DropdownDependency,
  DropdownOption,
  DropdownOptionsByField,
  DropdownRequest,
} from '../types/dropdown.types'

export const dropdownApi = {
  getAll: (activeOnly = true) =>
    api.get<DropdownOptionsByField>('/dropdowns/all', { params: { active_only: activeOnly } }),
  getByField: (fieldName: string, activeOnly = true) =>
    api.get<DropdownOption[]>(`/dropdowns/${fieldName}`, { params: { active_only: activeOnly } }),
  getFields: () => api.get<string[]>('/dropdowns/fields'),
  create: (data: Partial<DropdownOption> & { field_name: string }) => api.post('/dropdowns', data),
  update: (id: string | number, data: Partial<DropdownOption>) => api.put(`/dropdowns/${id}`, data),
  deactivate: (id: string | number) => api.post(`/dropdowns/${id}/deactivate`),
  reactivate: (id: string | number) => api.post(`/dropdowns/${id}/reactivate`),
  remove: (id: string | number) => api.delete(`/dropdowns/${id}`),
  getDependencies: (id: string | number) =>
    api.get<{ dependencies: DropdownDependency[] }>(`/dropdowns/${id}/dependencies`),
}

export const dropdownRequestApi = {
  list: (params?: { status?: string }) => api.get<DropdownRequest[]>('/dropdown-requests', { params }),
  create: (data: { field_name: string; requested_label: string; justification: string }) =>
    api.post('/dropdown-requests', data),
  approve: (id: string | number, data: { admin_comment?: string; prefix?: string | null } = {}) =>
    api.post(`/dropdown-requests/${id}/approve`, data),
  reject: (id: string | number, admin_comment = '') =>
    api.post(`/dropdown-requests/${id}/reject`, { admin_comment }),
}
